import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Czech
import csCommon from "./locales/cs/common.json";
import csNav from "./locales/cs/nav.json";
import csAuth from "./locales/cs/auth.json";
import csDashboard from "./locales/cs/dashboard.json";
import csCustomers from "./locales/cs/customers.json";
import csWorkers from "./locales/cs/workers.json";
import csZakazky from "./locales/cs/zakazky.json";
import csSchedules from "./locales/cs/schedules.json";
import csTasks from "./locales/cs/tasks.json";
import csPayroll from "./locales/cs/payroll.json";
import csReports from "./locales/cs/reports.json";
import csUsers from "./locales/cs/users.json";
import csChat from "./locales/cs/chat.json";
import csWebhooks from "./locales/cs/webhooks.json";
import csErrors from "./locales/cs/errors.json";
import csManual from "./locales/cs/manual.json";
import csAnalytics from "./locales/cs/analytics.json";
import csAttendance from "./locales/cs/attendance.json";
import csServer from "./locales/cs/server.json";

// English
import enCommon from "./locales/en/common.json";
import enNav from "./locales/en/nav.json";
import enAuth from "./locales/en/auth.json";
import enDashboard from "./locales/en/dashboard.json";
import enCustomers from "./locales/en/customers.json";
import enWorkers from "./locales/en/workers.json";
import enZakazky from "./locales/en/zakazky.json";
import enSchedules from "./locales/en/schedules.json";
import enTasks from "./locales/en/tasks.json";
import enPayroll from "./locales/en/payroll.json";
import enReports from "./locales/en/reports.json";
import enUsers from "./locales/en/users.json";
import enChat from "./locales/en/chat.json";
import enWebhooks from "./locales/en/webhooks.json";
import enErrors from "./locales/en/errors.json";
import enManual from "./locales/en/manual.json";
import enAnalytics from "./locales/en/analytics.json";
import enAttendance from "./locales/en/attendance.json";
import enServer from "./locales/en/server.json";

// Ukrainian
import ukCommon from "./locales/uk/common.json";
import ukNav from "./locales/uk/nav.json";
import ukAuth from "./locales/uk/auth.json";
import ukDashboard from "./locales/uk/dashboard.json";
import ukCustomers from "./locales/uk/customers.json";
import ukWorkers from "./locales/uk/workers.json";
import ukZakazky from "./locales/uk/zakazky.json";
import ukSchedules from "./locales/uk/schedules.json";
import ukTasks from "./locales/uk/tasks.json";
import ukPayroll from "./locales/uk/payroll.json";
import ukReports from "./locales/uk/reports.json";
import ukUsers from "./locales/uk/users.json";
import ukChat from "./locales/uk/chat.json";
import ukWebhooks from "./locales/uk/webhooks.json";
import ukErrors from "./locales/uk/errors.json";
import ukManual from "./locales/uk/manual.json";
import ukAnalytics from "./locales/uk/analytics.json";
import ukAttendance from "./locales/uk/attendance.json";
import ukServer from "./locales/uk/server.json";

// Russian
import ruCommon from "./locales/ru/common.json";
import ruNav from "./locales/ru/nav.json";
import ruAuth from "./locales/ru/auth.json";
import ruDashboard from "./locales/ru/dashboard.json";
import ruCustomers from "./locales/ru/customers.json";
import ruWorkers from "./locales/ru/workers.json";
import ruZakazky from "./locales/ru/zakazky.json";
import ruSchedules from "./locales/ru/schedules.json";
import ruTasks from "./locales/ru/tasks.json";
import ruPayroll from "./locales/ru/payroll.json";
import ruReports from "./locales/ru/reports.json";
import ruUsers from "./locales/ru/users.json";
import ruChat from "./locales/ru/chat.json";
import ruWebhooks from "./locales/ru/webhooks.json";
import ruErrors from "./locales/ru/errors.json";
import ruManual from "./locales/ru/manual.json";
import ruAnalytics from "./locales/ru/analytics.json";
import ruAttendance from "./locales/ru/attendance.json";
import ruServer from "./locales/ru/server.json";

export const NAMESPACES = [
  "common", "nav", "auth", "dashboard", "customers", "workers",
  "zakazky", "schedules", "tasks", "payroll", "reports", "users",
  "chat", "webhooks", "errors", "manual", "analytics", "attendance", "server",
] as const;

export const LANGUAGES = [
  { code: "cs", label: "Čeština", flag: "🇨🇿" },
  { code: "en", label: "English", flag: "🇬🇧" },
  { code: "uk", label: "Українська", flag: "🇺🇦" },
  { code: "ru", label: "Русский", flag: "🇷🇺" },
] as const;

/** Map i18n language code → BCP 47 locale for Intl APIs */
export const LOCALE_MAP: Record<string, string> = {
  cs: "cs-CZ",
  en: "en-GB",
  uk: "uk-UA",
  ru: "ru-RU",
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      cs: {
        common: csCommon, nav: csNav, auth: csAuth, dashboard: csDashboard,
        customers: csCustomers, workers: csWorkers, zakazky: csZakazky,
        schedules: csSchedules, tasks: csTasks, payroll: csPayroll,
        reports: csReports, users: csUsers, chat: csChat,
        webhooks: csWebhooks, errors: csErrors, manual: csManual, analytics: csAnalytics, attendance: csAttendance,
        server: csServer,
      },
      en: {
        common: enCommon, nav: enNav, auth: enAuth, dashboard: enDashboard,
        customers: enCustomers, workers: enWorkers, zakazky: enZakazky,
        schedules: enSchedules, tasks: enTasks, payroll: enPayroll,
        reports: enReports, users: enUsers, chat: enChat,
        webhooks: enWebhooks, errors: enErrors, manual: enManual, analytics: enAnalytics, attendance: enAttendance,
        server: enServer,
      },
      uk: {
        common: ukCommon, nav: ukNav, auth: ukAuth, dashboard: ukDashboard,
        customers: ukCustomers, workers: ukWorkers, zakazky: ukZakazky,
        schedules: ukSchedules, tasks: ukTasks, payroll: ukPayroll,
        reports: ukReports, users: ukUsers, chat: ukChat,
        webhooks: ukWebhooks, errors: ukErrors, manual: ukManual, analytics: ukAnalytics, attendance: ukAttendance,
        server: ukServer,
      },
      ru: {
        common: ruCommon, nav: ruNav, auth: ruAuth, dashboard: ruDashboard,
        customers: ruCustomers, workers: ruWorkers, zakazky: ruZakazky,
        schedules: ruSchedules, tasks: ruTasks, payroll: ruPayroll,
        reports: ruReports, users: ruUsers, chat: ruChat,
        webhooks: ruWebhooks, errors: ruErrors, manual: ruManual, analytics: ruAnalytics, attendance: ruAttendance,
        server: ruServer,
      },
    },
    lng: undefined, // let detector decide
    fallbackLng: "cs",
    defaultNS: "common",
    ns: NAMESPACES as unknown as string[],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      lookupLocalStorage: "uklid-language",
      caches: ["localStorage"],
    },
  });

export default i18n;
